const React = require('react');
const {AdminSubtitle, AdminFormRow, AdminFormCol} = require('../../../../../AdminLayout');
const {AdminSwitch} = require('../../../../../../FormInputs');

module.exports = ({title, ids, formCtx, disableLayout}) => {
  return (
    <>
      <AdminSubtitle text={title} />
      <AdminFormRow>
        {ids.map((name) => (
          <AdminFormCol
            key={name}
            className={'mt20 wmax.disableLayout' + (disableLayout ? ` disableLayout` : '')}
          >
            <AdminSwitch
              name={name}
              formCtx={formCtx}
            />
          </AdminFormCol>
        ))}
      </AdminFormRow>
    </>
  )
}
